import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';

@Component({
  selector: 'app-tour-agencias',
  templateUrl: './tour-agencias.component.html',
  styleUrls: ['./tour-agencias.component.css']
})
export class TourAgenciasComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  subscriptionAg: Subscription;
  form: FormGroup;
  subscriptionPas: any;
  idPaquete: Number;
  idAgencia: Number;
  paqueteReservado = [];
  listaReservaciones = [];
  listaAgencias = [];
  cantidadReservaciones: number;
  idPaquetePasajero: Number;
  auxService: any;

  filtered: Object[];
  

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
    private route: ActivatedRoute
  ) { }


  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
     this.subscription.unsubscribe();
     this.subscriptionAg.unsubscribe();
     this.subscriptionPas.unsubscribe();
  }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      search: [''],     
    });


    this.subscription = this.tourservice.paqueteReservado.subscribe(result => {
        this.idPaquete = result;
    });

    this.subscriptionAg = this.tourservice.agenciaReserva.subscribe(result => {
      this.idAgencia = result;
    });

    this.subscriptionPas = this.tourservice.paqueteReservadoPasajero.subscribe(result => {
      this.idPaquetePasajero = result;
    });

    this.reservacionesTour();
    this.listaDeAgencias();
  }

  verAgencia(id){
    this.idAgencia = id;
    this.idPaquetePasajero = this.idPaquete;
    this.tourservice.changeAgenciaId(this.idAgencia);
    this.tourservice.changePaqueteIdPasajero(this.idPaquetePasajero);
    //console.log("la agencia que se toco es:  "+id);
    this.router.navigate(['/admin/tours-agencias-reservados']);
  }

  reservacionesTour(){  
    this.listaReservaciones = [];
    this.agenciasService.reservacionesTour(this.idPaquete).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.cantidadReservaciones = data.body.length;
          this.listaReservaciones = data.body;
          this.paqueteReservado =  this.listaReservaciones[0].id_paquete;
          //this.filtered = data.body;
        }
        //console.log("cantidad de reservaciones:  " + this.cantidadReservaciones);
        //console.log("el paquete reservado es:  " + this.paqueteReservado);    
        //console.log(this.listaReservaciones);  
        //console.log(this.filtered);  
      }    
    });    
  }

  listaDeAgencias(){
    this.listaAgencias = [];
    this.agenciasService.agenciasPaquete(this.idPaquete).subscribe(data => {
      if(data instanceof HttpResponse){
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.listaAgencias = data.body;
          this.filtered = data.body; console.log(this.filtered );
        }
      }
    })
  }

  get f() { 
    return this.form.controls; 
  }

  onSubmit() { 
    var value = this.f.search.value;
    var recibido = [];
    if(value === ''){
      this.redirectTo(this.router.url); 
    }else {
      var paquete = this.idPaquete.toString(); console.log(paquete + value);
      this.agenciasService.agenciasFiltradas(value, paquete, '1').subscribe(data => {
        if(data instanceof HttpResponse){
          if(data.body !== null && data.body !== undefined && data.body !== ''){
            this.listaAgencias = data.body;
            this.filtered = data.body; console.log(this.filtered );
          }
        }
      });
      
    }
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }  
  

}
